import { render, staticRenderFns } from "./productunit.vue?vue&type=template&id=073a5a3d&"
import script from "./productunit.vue?vue&type=script&lang=js&"
export * from "./productunit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports